import { useRouter } from 'vue-router';
import { getHostRouter } from '@Src/mfe.config';
import { useEsignatureFlowStore } from '@Src/stores/esignatureFlow.store';

const useFlowNavigation = () => {
    const router = useRouter();
    const hostRouter = getHostRouter();
    const esignatureFlowStore = useEsignatureFlowStore();

    const advanceFlow = () => {
        const currentQuery = router.currentRoute.value.query;
        const nextTask = esignatureFlowStore.getNextFlowTask();

        nextTask ?
            router.push({ name: nextTask.routeName, query: currentQuery }) :
            continueMainFlow();
    };

    const goBackInFlow = () => {
        const currentQuery = router.currentRoute.value.query;
        const prevTask = esignatureFlowStore.getPreviousFlowTask();

        prevTask ?
            router.push({ name: prevTask.routeName, query: currentQuery }) :
            navigateToMfeStart();
    };

    const advanceFlowReplace = () => {
        const currentQuery = router.currentRoute.value.query;
        const nextTask = esignatureFlowStore.getNextFlowTask();

        nextTask ?
            router.replace({ name: nextTask.routeName, query: currentQuery }) :
            continueMainFlow();
    };

    const resumeFlow = () => {
        const currentQuery = router.currentRoute.value.query;
        const nextTask = esignatureFlowStore.getCurrentFlowTask();

        nextTask ?
            router.replace({ name: nextTask.routeName, query: currentQuery }) :
            continueMainFlow();
    };

    const continueMainFlow = () => {
        const companySlug = hostRouter.currentRoute.value.params.companySlug;
        hostRouter.push({
            name: 'continue-flow',
            params: { companySlug }
        });
    };

    const navigateToWhatsNext = () => {
        router.push({ name: 'whats-next' });
    };


    return {
        advanceFlow,
        advanceFlowReplace,
        goBackInFlow,
        resumeFlow,
        continueMainFlow,
        navigateToWhatsNext
    };
};

export default useFlowNavigation;